<template>
    <isc-dialog
        title="修改密码"
        :visible.sync="dialogFormVisible"
        width="350px"
        modal-append-to-body
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <isc-form ref="form" label-position="right" :model="form" :rules="rules" label-width="80px">
            <isc-form-item label="旧密码" prop="oldPassword" required>
                <isc-input v-model="form.oldPassword" type="password" autocomplete="off"></isc-input>
            </isc-form-item>
            <isc-form-item label="密码" prop="password" required>
                <isc-input v-model="form.password" type="password" autocomplete="off"></isc-input>
            </isc-form-item>
            <isc-form-item label="确认密码" prop="checkPassword" required>
                <isc-input v-model="form.checkPassword" type="password" autocomplete="off"></isc-input>
            </isc-form-item>
        </isc-form>
        <div slot="footer" class="dialog-footer">
            <isc-button type="primary" @click="updatePassword">确 认</isc-button>
            <isc-button plain @click="dialogFormVisible = false">取 消</isc-button>
        </div>
    </isc-dialog>
</template>

<script>
import { va } from '@isyscore/classes/validation';
import { showSuccess } from '@/utils/message.ts';
import { changePwd } from '@/components/desk-header/components/user-dialog/service';

export default {
    name: 'ChangePasswordDialog',

    data() {
        return {
            dialogFormVisible: false,
            form: {
                oldPassword: '',
                password: '',
                checkPassword: ''
            },
            rules: {
                oldPassword: va.required().flex(5, 18).trigger('blur'),
                password: va.required().flex(5, 18).trigger('blur'),
                checkPassword: va.required().flex(5, 18).same('password', '确认密码不正确').trigger('blur')
            }
        };
    },

    methods: {
        open() {
            this.dialogFormVisible = true;
        },

        async updatePassword() {
            try {
                await this.$refs.form.validate();
            } catch (err) {
                return;
            }

            try {
                await changePwd(this.form.oldPassword, this.form.password);
            } catch (error) {
                return;
            }

            showSuccess('修改成功');
            this.dialogFormVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped></style>
